export interface Indexed {
  index: number;
}

export interface ListPage<T> {
  list: T[];
  index: number;
  total: number;
  size: number;
}

export enum Priority {
  Critical = "Critical",
  Major = "Major",
  Minor = "Minor",
  Informational = "Informational",
}
